module.exports = __webpack_public_path__ + "static/img/a301.dbc9494b.png";